var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.45 19.85L31.1 23.65L15.05 31.7C15.05 31.7 12.95 32.75 11.95 31.1C7.95001 24.6 27.45 19.85 27.45 19.85",
    fill: "#256382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 26.95C14.6 26.95 11.55 28.1 12.1 30.25C12.7 32.5 15.15 31.15 15.15 31.15L30.4 23.65C30.4 23.65 29.55 21.25 31.1 19.65L14.6 26.95",
    fill: "#D9E3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 4.45001L31.8 19.5L14.55 26.65L3.5 8.35001L17.2 4.45001Z",
    fill: "#42ADE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.35 21.3L20.15 25.7L30.15 20.85L30.35 21.3ZM30.2 22.6L19.35 27.35L30 22.15L30.2 22.6ZM30.3 23.35L16.45 29.7L30.1 22.9L30.3 23.35Z",
    fill: "#94989B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 31.05C10.2 27.3 14.55 26.65 14.55 26.65L3.5 8.35001C3.5 8.35001 1 8.30001 1 11.05C1 12.2 1.5 13.05 1.5 13.05L11.9 31.05Z",
    fill: "#428BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35001 16.1L0.700012 19.9L16.75 27.95C16.75 27.95 18.85 29 19.85 27.35C23.85 20.85 4.35001 16.1 4.35001 16.1",
    fill: "#547725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.15 23.2C17.15 23.2 20.2 24.35 19.65 26.5C19.05 28.75 16.65 27.4 16.65 27.4L1.40001 19.9C1.40001 19.9 2.25001 17.5 0.700012 15.9L17.15 23.2Z",
    fill: "#D9E3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6 0.700012L0 15.75L17.25 22.9L28.3 4.60001L14.6 0.700012Z",
    fill: "#83BF4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60002 17.1L11.6 21.95L1.40002 17.55L1.60002 17.1ZM1.80002 18.4L12.4 23.6L1.55002 18.85L1.80002 18.4ZM1.70002 19.15L15.3 25.95L1.45002 19.6L1.70002 19.15Z",
    fill: "#94989B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 27.3C21.6 23.55 17.25 22.9 17.25 22.9L28.3 4.60001C28.3 4.60001 30.8 4.55001 30.8 7.30001C30.8 8.45001 30.3 9.30001 30.3 9.30001L19.9 27.3Z",
    fill: "#699635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35 13L31.4 16.2L17.85 22.95C17.85 22.95 16.05 23.8 15.2 22.45C11.9 17 28.35 13 28.35 13Z",
    fill: "#962C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19C17.5 19 14.9 19.95 15.4 21.8C15.9 23.7 17.95 22.55 17.95 22.55L30.8 16.2C30.8 16.2 30.1 14.2 31.4 12.85L17.5 19Z",
    fill: "#D9E3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 0L32 12.7L17.45 18.75L8.09998 3.3L19.7 0Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 2.89999L22.45 5.54999L13.6 8.89999L11.5 5.49999L20.05 2.89999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 14.25L22.2 17.9L30.6 13.8L30.8 14.25ZM30.7 15.35L21.5 19.3L30.5 14.9L30.7 15.35ZM30.8 15.95L19.1 21.3L30.55 15.5L30.8 15.95Z",
    fill: "#94989B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 22.45C13.85 19.3 17.5 18.75 17.5 18.75L8.10001 3.30001C8.10001 3.30001 5.95001 3.25001 5.95001 5.55001C5.95001 6.50001 6.35001 7.25001 6.35001 7.25001L15.25 22.45Z",
    fill: "#C94747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomStories);
export default __webpack_public_path__ + "static/media/custom_stories.42cf53b57fb40105a4fb88b036c2abfa.svg";
export { ForwardRef as ReactComponent };